import { Nav } from "@/components/Nav";
import { SiteFooter } from "@/components/SiteFooter";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-brand-paper text-brand-black flex flex-col">
      <Nav />
      <main className="flex-1 pt-36 pb-24 px-6">
        <div className="max-w-2xl mx-auto">
          <p className="font-mono text-[11px] font-bold tracking-[0.28em] text-brand-red uppercase">
            Terms
          </p>
          <h1 className="mt-4 font-serif font-black text-display-md text-brand-black">
            The basics.
          </h1>
          <div className="mt-12 space-y-7 text-lg text-brand-ink leading-relaxed">
            <p>
              By signing up you agree to receive daily emails about your selected
              teams' games during the MLB season. You can cancel anytime via the
              Manage Subscription link in every email. No refunds. Whatever's
              left of your current billing period continues until it expires.
            </p>
            <p>
              We're not affiliated with Major League Baseball or any MLB club,
              player, or broadcaster. We're a fan-run newsletter.
            </p>
            <p>
              You're responsible for keeping your email address current and your
              payment method valid. If a charge fails, your subscription pauses
              until you fix it. We don't email you about it. Stripe handles that.
            </p>
            <p>
              If we change these terms, the change takes effect on your next
              billing period. We'll send a heads-up before any change matters.
            </p>
            <p>
              Questions? Email{" "}
              <a
                href="mailto:clubhouse@theboxscoreclub.com"
                className="text-brand-red underline underline-offset-2 hover:text-brand-red-hover transition-colors"
              >
                clubhouse@theboxscoreclub.com
              </a>
              .
            </p>
            <p className="text-sm text-brand-muted pt-8 border-t border-brand-rule">
              Last updated: April 2026.
            </p>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
